import React from 'react';
import { Button, Card, FormField, Input } from '../ui';

type AccountCardProps = {
  accountUsername: string;
  setAccountUsername: React.Dispatch<React.SetStateAction<string>>;
  accountEmail: string;
  setAccountEmail: React.Dispatch<React.SetStateAction<string>>;
  savingAccount: boolean;
  handleSaveAccount: () => void;
};

export function AccountCard({
  accountUsername,
  setAccountUsername,
  accountEmail,
  setAccountEmail,
  savingAccount,
  handleSaveAccount,
}: AccountCardProps) {
  return (
    <Card elevation="raised">
      <Card.Header>
        <Card.Title subtitle="Your login credentials and display name.">
          <span className="settings-section-icon">👤</span> Account
        </Card.Title>
      </Card.Header>
      <Card.Body className="settings-card-body">
        <FormField
          label="Username"
          htmlFor="account-username"
          hint="Used to identify your account internally."
        >
          <Input
            id="account-username"
            value={accountUsername}
            onChange={(e) => setAccountUsername(e.target.value)}
            placeholder="your_username"
          />
        </FormField>
        <FormField
          label="Email"
          htmlFor="account-email"
          hint="Used for login and account recovery."
        >
          <Input
            id="account-email"
            type="email"
            value={accountEmail}
            onChange={(e) => setAccountEmail(e.target.value)}
            placeholder="you@example.com"
          />
        </FormField>
        <Button variant="primary" size="sm" loading={savingAccount} onClick={handleSaveAccount}>
          Save account
        </Button>
      </Card.Body>
    </Card>
  );
}
